import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { SideBar, NavBar, Footer, TitleAndDescription } from "../../components";
import queryString from "query-string";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
const { formatarReal } = require("../../utils");

class OrcamentoDetalhe extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
    this.loadPedido = this.loadPedido.bind(this);
    this.state = {
      idPedido: queryString.parse(this.props.location.search).id,
      pedido: null,
    };
  }

  async componentDidMount() {
    await this.load();
  }

  async load() {
    await this.loadPedido();
  }

  async loadPedido() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/orcamento/${this.state.idPedido}`,
        this.props.parameters()
      )
      .then((response) => {
        this.setState({ pedido: response.data.pedido });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
        }
      });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Detalhe do orçamento"/>
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"orcamentos"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title="Orçamento"
                  description="Visualização completa do orçamento."
                /> */}

                {this.state.pedido !== null && (
                  <React.Fragment>
                    <div className="row" style={{ lineHeight: "1.6" }}>
                      <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-7 col-sm-6">
                                <div
                                  className="float-left width-100"
                                  style={{ paddingBottom: "5px" }}
                                >
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "#80217e",
                                      fontSize: "17px",
                                    }}
                                  >
                                    #{this.state.pedido.codigo}
                                  </span>
                                </div>

                                <div className="float-left width-100 font-size-16">
                                  <span> {this.state.pedido.cliente.desc}</span>
                                </div>

                                <div className="float-left width-100 font-size-14">
                                  <span>
                                    {this.state.pedido.cliente.fantasia}
                                  </span>
                                </div>

                                <div
                                  className="float-left width-100 font-size-14"
                                  style={{ paddingTop: "20px" }}
                                >
                                  <span style={{ fontWeight: "bold" }}>
                                    Endereço principal
                                  </span>
                                </div>

                                <div className="row">
                                  <div
                                    className="col-1 d-flex"
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <i
                                      className="fa fa-map-marker"
                                      syle="font-size:22px"
                                      style={{
                                        fontSize: "30px",
                                        color: "#666",
                                      }}
                                    ></i>
                                  </div>

                                  <div className="col-11 font-size-14">
                                    <div>
                                      {
                                        this.state.pedido.enderecoEntrega
                                          .endereco
                                      }
                                      ,{" "}
                                      {this.state.pedido.enderecoEntrega.numero}
                                    </div>
                                    <div>
                                      {
                                        this.state.pedido.enderecoEntrega
                                          .complemento
                                      }
                                    </div>
                                    <div>
                                      {this.state.pedido.enderecoEntrega.bairro}{" "}
                                      -{" "}
                                      {this.state.pedido.enderecoEntrega.cidade}{" "}
                                      -{" "}
                                      {this.state.pedido.enderecoEntrega.estado}
                                    </div>
                                    <div>
                                      {" "}
                                      CEP:{" "}
                                      {this.state.pedido.enderecoEntrega.cep}
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="float-left width-100 font-size-14"
                                  style={{ paddingTop: "20px" }}
                                >
                                  <span style={{ fontWeight: "bold" }}>
                                    Financeiro
                                  </span>
                                </div>

                                <div className="row font-size-14">
                                  <div className="col-md-12">
                                    <div className="row">
                                      <div className="col-md-6">
                                        Condição de pagamento
                                        <span className="display-block-detalhe">
                                          {this.state.pedido.condPagto.desc}
                                        </span>
                                      </div>
                                      <div className="col-md-6">
                                        Forma de pagamento
                                        <span className="display-block-detalhe">
                                          {this.state.pedido.formaPagto.desc}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="row"
                                  style={{ marginTop: "20px" }}
                                >
                                  <div className="col-md-12">
                                    <span
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Outras Informações
                                    </span>
                                  </div>
                                </div>

                                <div className="row font-size-14">
                                  <div className="col-md-12">
                                    <div className="row">
                                      <div className="col-md-6">
                                        Transportadora
                                        <span className="display-block-detalhe">
                                          {
                                            this.state.pedido.transportadora
                                              .desc
                                          }
                                        </span>
                                      </div>
                                      <div className="col-md-6">
                                        Tipo de pedido
                                        <span className="display-block-detalhe">
                                          {this.state.pedido.tipoPedido.desc}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {this.state.pedido.previsaoEntrega !==
                                  undefined && (
                                  <div
                                    className="row"
                                    style={{ marginTop: "20px" }}
                                  >
                                    <div className="col-md-12">
                                      <span
                                        style={{
                                          fontSize: "13px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Previsão de Entrega
                                      </span>
                                      <span className="display-block-detalhe font-size-14">
                                        <i className="fa fa-calendar"></i>{" "}
                                        {moment(
                                          this.state.pedido.previsaoEntrega
                                        ).format("DD/MM/YYYY")}
                                      </span>
                                    </div>
                                  </div>
                                )}
                              </div>

                              <div className="col-md-5 col-sm-6">
                                <div
                                  id="titulo-situacao"
                                  className="float-left width-100 font-size-14"
                                  style={{ paddingBottom: "5px" }}
                                >
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                    }}
                                    className={`${this.state.pedido.expiracao.cor.toLowerCase()}`}
                                  >
                                    {this.state.pedido.expiracao.desc}
                                  </span>
                                </div>

                                <div className="float-left width-100 font-size-14">
                                  <i className="fa fa-calendar"></i>{" "}
                                  {moment(this.state.pedido.data).format(
                                    "DD/MM/YYYY"
                                  )}
                                </div>

                                <div
                                  id="titulo-contato-pedido"
                                  className="float-left width-100 font-size-14"
                                >
                                  <span style={{ fontWeight: "bold" }}>
                                    Contato do pedido
                                  </span>
                                </div>

                                <div className="row">
                                  <div
                                    className="col-1 d-flex"
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <i
                                      className="fa fa-phone"
                                      syle="font-size:22px"
                                      style={{
                                        fontSize: "30px",
                                        color: "#666",
                                      }}
                                    ></i>
                                  </div>

                                  <div className="col-11 font-size-14">
                                    <div>{this.state.pedido.contato.desc}</div>
                                    <div>{this.state.pedido.contato.email}</div>
                                    <div>{this.state.pedido.contato.fone}</div>
                                    <div>{this.state.pedido.contato.cel}</div>
                                  </div>
                                </div>

                                <div
                                  className="row font-size-14"
                                  style={{ paddingTop: "20px" }}
                                >
                                  <div className="col-md-12">
                                    <div className="float-left width-100">
                                      <span>Observação</span>{" "}
                                      <span className="display-block-detalhe">
                                        {this.state.pedido.observacao}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">
                          <div className="card-body">
                            <div className="table-responsive">
                              <table
                                id="recent-purchases-listing"
                                className="table"
                              >
                                <thead>
                                  <tr>
                                    <th>Código</th>
                                    <th style={{ maxWidth: "350px" }}>
                                      Descrição
                                    </th>
                                    <th>U.M</th>
                                    <th
                                      className="text-right"
                                      style={{ minWidth: "115px" }}
                                    >
                                      Quantidade
                                    </th>
                                    <th className="text-right">Preço unit.</th>
                                    <th className="text-right">Desconto</th>
                                    <th
                                      className="text-right"
                                      style={{ minWidth: "140px" }}
                                    >
                                      Total do item
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.pedido.itens.map((item, key) => (
                                    <tr key={key}>
                                      <td style={{ fontWeight: "bold" }}>
                                        #{item.produto.cod}
                                      </td>
                                      <td style={{ maxWidth: "350px" }}>
                                        {item.produto.desc}
                                      </td>
                                      <td>{item.produto.unid}</td>
                                      <td className="text-right">
                                        {item.quantidade}
                                      </td>
                                      <td className="text-right">
                                        R${" "}
                                        {formatarReal(
                                          item.produto.preco
                                            .precoUnitComImpostosFinal
                                        )}
                                      </td>
                                      <td className="text-right">
                                        R${" "}
                                        {formatarReal(
                                          item.produto.preco.valorDesconto
                                        )}
                                      </td>
                                      <td className="text-right">
                                        R${" "}
                                        {formatarReal(
                                          parseFloat(
                                            (
                                              item.produto.preco
                                                .precoUnitComImpostosFinal *
                                              item.quantidade
                                            ).toFixed(2)
                                          )
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">
                          <div className="card-body">
                            <span
                              className="float-left width-100 font-size-16"
                              style={{ textAlign: "right", fontWeight: "bold" }}
                            >
                              Total do pedido:&nbsp;&nbsp;&nbsp;
                              <span
                                className="font-size-22"
                                style={{ color: "#6ACA25", fontWeight: "bold" }}
                              >
                                R$ {formatarReal(this.state.pedido.valorTotal)}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default OrcamentoDetalhe;
